<template>
  <div class="feature-index-ticker ub ub-btw">
    <div class="feature-index-ticker-symbol ub ub-cen">
      <img src="@/assets/images/feature/choose.svg" @click="onShowMarket"/>
      <p>
        {{coins}}/USDT
      </p>
      <span>
        {{ $t('features.perpetual') }}
      </span>
      <div class="rate ub ub-btw" :style="{ color: `var(${rate})` }">
        {{ price24.lastPrice }}  {{ sym }}{{ price24.percent }}
      </div>
    </div>
    <img src="@/assets/images/nav/markets.svg" @click="onChart"/>
  </div>
</template>
<script>
export default {
  props: {
    price24: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    sym () {
      return this.price24?.percent.indexOf('-') !== -1 ? '' : '+'
    },
    rate () {
      return this.price24?.percent.indexOf('-') !== -1
        ? '--down-color'
        : '--up-color'
    },
    symbol () {
      return this.$route.params.symbol || 'BTCUSDT'
    },
    coins () {
      return this.symbol.replace('USDT', '')
    }
  },
  methods: {
    onChart () {
      this.$router.push(`/trade/spot-kline/${this.symbol}`)
    },
    onShowMarket () {
      this.$emit('showMarket', true)
    }
  }
}
</script>
<style lang="less">
.feature-index-ticker {
  height: 128px;
  padding: 24px 32px;
  margin-bottom: 16px;
  box-sizing: border-box;
  position: relative;
  img {
    width: 48px;
    height: 48px;
  }
  &-symbol {
    color: var(--main-text-1);
    font-family: Roboto;
    font-size: 40px;
    font-style: normal;
    font-weight: 500;
    line-height: 56px;
    .rate {
      position: absolute;
      font-family: Roboto;
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: 40px;
      height: 40px;
      bottom: -1px;
      left: 104px;
    }
    p {
      margin: 0 16px 0 24px;
    }
    span {
      color: var(--main-text-3);
      font-family: Roboto;
      font-size: 28px;
      line-height: 40px; /* 142.857% */
    }
  }
  .up {
    color: var(--up-color);
  }
  .down {
    color: var(--down-color);
  }
}
</style>
